// The columns every data CSV ends with, so a file still says what it holds after it has been
// emailed around: the country, where the data comes from, the measure and the UTC window the job
// asked for. Imports config only.
import { COUNTRIES } from '../config/countries';
import type { CountryCode } from '../config/countries';
import { DATA_SOURCES, MEASURES, capability } from '../config/products';
import type { DataProductId, MeasureKey } from '../config/products';
import type { WindowUtc } from './submittedWindow';

export const CONTEXT_HEADERS = ['Country', 'Source', 'Measure', 'Window start (UTC)', 'Window end (UTC)'] as const;

/** One value per CONTEXT_HEADERS entry. A product the country lacks has no source; a missing window is blank. */
export function contextValues(c: CountryCode, p: DataProductId, m: MeasureKey, w: WindowUtc | null): string[] {
  const cap = capability(c, p);
  return [
    COUNTRIES[c].label,
    cap ? DATA_SOURCES[cap.source].name : '',
    MEASURES[m].label,
    w ? w.start : '',
    w ? w.end : '',
  ];
}
